import { isoDate, resolveDates } from '../dates';
import type { Engine } from '../types';
import { buildUrl } from '../url';

// Both checked on the live sites (Oct 2026): Ticketmaster takes
// startDate/endDate (YYYY-MM-DD) and sort=date; StubHub's sort by date is
// sortBy=0, and its date and location filters aren't in the URL.

export const ticketmaster: Engine = {
  id: 'ticketmaster',
  name: 'Ticketmaster',
  bang: 'tm',
  aliases: ['ticketmaster'],
  homepage: 'https://www.ticketmaster.com',
  category: 'Events',
  defaultOn: false,
  description: 'Concerts, sports and shows by date: !tm.wknd jazz.',
  params: [
    {
      id: 'dates',
      type: 'dates',
      label: 'Dates',
      group: 'Dates',
      help: 'One date, a range (11/1-11/30), wknd, tmrw or +7.',
    },
    {
      id: 'sort',
      type: 'choice',
      label: 'Sort',
      group: 'Sort',
      options: [{ value: 'date', token: 'soonest', label: 'Soonest first' }],
    },
  ],
  build({ query, values }) {
    const range =
      typeof values.dates === 'string' ? resolveDates(values.dates) : undefined;
    return buildUrl('https://www.ticketmaster.com/search', {
      q: query,
      startDate: range && isoDate(range.start),
      endDate: range && isoDate(range.end),
      sort: values.sort as string | undefined,
    });
  },
};

export const stubhub: Engine = {
  id: 'stubhub',
  name: 'StubHub',
  bang: 'stub',
  aliases: ['stubhub'],
  homepage: 'https://www.stubhub.com',
  category: 'Events',
  defaultOn: false,
  description: 'Resale tickets for concerts, sports and shows.',
  params: [
    {
      id: 'sort',
      type: 'choice',
      label: 'Sort',
      group: 'Sort',
      options: [{ value: '0', token: 'soonest', label: 'Soonest first' }],
    },
  ],
  build({ query, values }) {
    return buildUrl('https://www.stubhub.com/search', {
      q: query,
      sortBy: values.sort as string | undefined,
    });
  },
};
